'use strict';
// eslint-disable-next-line es/no-typed-arrays -- safe
module.exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';



//////////////////
// WEBPACK FOOTER
// ./node_modules/twilsock/node_modules/core-js/internals/array-buffer-basic-detection.js
// module id = 2582
// module chunks = 25